import PropTypes from 'prop-types';
import { Link } from 'dibs-elements/exports/Link';
import { trackUserInteractionOnce } from '../../helpers/checkoutTracking';
import { PANES } from '../../constants/checkoutConstants';

const CheckoutAction = ({ type, serviceId, action, actionType, onClick }) => {
    const dataTn = ['action', actionType, type, serviceId].join('-');
    const onClickHandler = event => {
        trackUserInteractionOnce();
        onClick(event);
    };
    return (
        <Link buyerLinkType="standardLink" dataTn={dataTn} onClick={onClickHandler}>
            {action}
        </Link>
    );
};

CheckoutAction.propTypes = {
    type: PropTypes.oneOf([PANES.PANE_SHIPPING, PANES.PANE_PAYMENT]).isRequired,
    serviceId: PropTypes.string.isRequired,
    actionType: PropTypes.string.isRequired,
    action: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default CheckoutAction;
